import type { ResolvedBetterstartConfig } from '@cli-types/core-engine/config.js'
import { applyAdminNamespaceToContent } from '@next-adapter/config/namespace/apply-admin-namespace-to-content.js'

export function namespaceInstallableContent(
  config: ResolvedBetterstartConfig,
  content: string
): string {
  return applyAdminNamespaceToContent(content, config.frameworkConfig.next.namespace)
}
